import { GlobalStyles } from '@mui/material';

/**
 * Global CSS using MUI v5+ GlobalStyles component
 *
 * Los colores salen de las variables del tema (`--mui-palette-*`, generadas por
 * `cssVariables` en src/theme/theme.ts) y de los tokens compartidos con
 * sporttia-competitions (`--link`, `--card`, `--muted`, ver src/index.css), para
 * que todo siga al modo claro/oscuro.
 */
export default function GlobalCSS() {
    return (
        <GlobalStyles
            styles={{
                // Table
                '.MuiTableCell-sizeSmall': {
                    paddingLeft: 10,
                    paddingRight: 10,
                },

                // Links
                a: {
                    color: 'var(--link)',
                    textDecoration: 'none',
                },
                'a:hover': {
                    color: 'var(--link-hover)',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                },
                '.MuiTypography-colorPrimary': {
                    color: 'var(--link)',
                },
                '.MuiTypography-colorPrimary:hover': {
                    color: 'var(--link-hover)',
                },
                '.MuiLink-root': {
                    color: 'var(--link)',
                    textDecoration: 'none',
                },
                '.MuiLink-root:hover': {
                    color: 'var(--link-hover)',
                    textDecoration: 'underline',
                },

                // Buttons
                // El lima de marca es fondo: en los botones sin relleno el
                // borde va en el lima oscuro y el texto en el lima legible.
                '.MuiButton-outlinedPrimary': {
                    borderColor: 'var(--mui-palette-primary-dark)',
                    color: 'var(--brand-text)',
                },
                '.MuiButton-outlinedPrimary:hover': {
                    borderColor: 'var(--mui-palette-primary-dark)',
                    backgroundColor: 'rgba(186, 242, 0, 0.12)',
                },
                // Green buttons (contained primary)
                '.MuiButton-containedPrimary': {
                    backgroundColor: 'var(--mui-palette-primary-main)',
                    color: 'var(--mui-palette-primary-contrastText) !important',
                },
                '.MuiButton-containedPrimary .MuiSvgIcon-root': {
                    color: 'var(--mui-palette-primary-contrastText) !important',
                },
                '.MuiButton-containedPrimary:hover': {
                    backgroundColor: 'var(--mui-palette-primary-dark)',
                },
                // Red buttons (delete) - white text
                '.MuiButton-contained.button-delete': {
                    backgroundColor: 'var(--mui-palette-error-main)',
                    color: '#fff !important',
                },
                '.MuiButton-contained.button-delete:hover': {
                    backgroundColor: 'var(--mui-palette-error-dark)',
                },
                '.MuiButton-contained.button-delete:disabled': {
                    backgroundColor:
                        'var(--mui-palette-action-disabledBackground)',
                    color: 'var(--mui-palette-action-disabled) !important',
                },
                '.MuiButton-contained.button-delete .MuiSvgIcon-root': {
                    color: '#fff !important',
                },
                '.MuiButton-textPrimary': {
                    color: 'var(--brand-text)',
                },
                '.MuiButton-textPrimary:hover': {
                    color: 'var(--link-hover)',
                    backgroundColor: 'rgba(186, 242, 0, 0.12)',
                },

                // Form input
                '.MuiInputBase-root': {
                    backgroundColor: 'var(--card)',
                },

                // Dialogs
                '.MuiDialogContent-root': {
                    backgroundColor: 'var(--muted)',
                },

                // Los tooltips los define el tema (MuiTooltip), calcados de
                // sporttia-competitions.

                '.MuiFab-primary': {
                    backgroundColor: 'var(--mui-palette-primary-main)',
                    color: 'var(--mui-palette-primary-contrastText)',
                },
                '.MuiFab-primary:hover': {
                    backgroundColor: 'var(--mui-palette-primary-dark)',
                },
            }}
        />
    );
}
